/* gj-motion.js - Gentle Journeys, 14 Oct 2026 design pass. Small, deferred, no library. Every piece below ENHANCES a
   page that is already complete without it (static first): tabs show every panel, links still go to their bag, forms
   still post. Nothing here opens a pop-up. Reduced motion: no auto-turning, no smooth scrolling (CSS shows final states).
   1  reveal: sections settle in as they arrive (adds .is-in; the hidden start state applies only once this runs)
   2  journey hero: tap a trip, the photo and the bag card change, and the compare table marks that bag
   3  tabs: "what's inside" groups become tabs
   4  compare: Add to cart from the table opens the cart drawer (falls back to the plain form post)
   5  the card: EN / DE / FR / ES, turning on its own until someone taps
   6  journey route: tap a stop, the plane flies to it, the panel changes
   7  FAQ: the question filter
   8  checklist: tick a step (remembered on this device only)
   9  bag chooser (gj-bag-chooser): tap an answer, the bag that fits shows
   10 header option A/B on the unpublished draft only (?gjh=a | ?gjh=b), for the meeting
   11 preview links: ?view= on links to the bags, the bags collection and the kit (unpublished draft only) */
(function () {
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var root = document.documentElement;
  function $$(sel, el) { return Array.prototype.slice.call((el || document).querySelectorAll(sel)); }

  /* 1 reveal */
  var rv = $$('[data-gj-rv], .gj-set--steps .gj-set__item');
  if (!('IntersectionObserver' in window) || reduce) {
    rv.forEach(function (s) { s.classList.add('is-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      root.classList.add('gj-mo');
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); } });
    }, { rootMargin: '0px 0px -10% 0px', threshold: 0.08 });
    rv.forEach(function (s) { io.observe(s); });
  }

  /* 2 journey hero */
  $$('[data-gj-hero]').forEach(function (hero) {
    var trips = $$('[data-gj-trip]', hero);
    trips.forEach(function (t) {
      t.setAttribute('role', 'button');
      if (!t.hasAttribute('aria-pressed')) t.setAttribute('aria-pressed', 'false');
      t.addEventListener('click', function (ev) {
        ev.preventDefault();
        var id = t.getAttribute('data-gj-trip');
        trips.forEach(function (x) { x.setAttribute('aria-pressed', x === t ? 'true' : 'false'); });
        $$('[data-gj-photo]', hero).forEach(function (p) { p.classList.toggle('is-on', p.getAttribute('data-gj-photo') === id); });
        $$('[data-gj-card]', hero).forEach(function (c) {
          var on = c.getAttribute('data-gj-card') === id;
          c.hidden = !on; c.classList.toggle('is-on', on);
        });
        /* the trip they tapped is carried down the page: the compare table marks that bag's column (FIX ROUND 15 Oct) */
        var h = t.getAttribute('data-gj-h');
        $$('.gj-cmp').forEach(function (cmp) {
          if (h) cmp.setAttribute('data-pick', h); else cmp.removeAttribute('data-pick');
          $$('[data-gj-h]', cmp).forEach(function (c) { c.classList.toggle('is-pick', c.getAttribute('data-gj-h') === h); });
        });
      });
    });
  });

  /* 3 tabs (what's inside) */
  $$('[data-gj-tabs]').forEach(function (sec) {
    var list = sec.querySelector('[data-gj-tablist]');
    if (!list) return;
    var tabs = $$('[role="tab"]', list);
    var panels = $$('[data-gj-panel]', sec).filter(function (p) { return !p.hasAttribute('data-gj-off'); });
    list.hidden = false;
    sec.classList.add('is-tabbed');
    $$('[data-gj-nojs]', sec).forEach(function (h) { h.hidden = true; });
    function select(i, focus) {
      tabs.forEach(function (t, k) { t.setAttribute('aria-selected', k === i ? 'true' : 'false'); t.tabIndex = k === i ? 0 : -1; });
      panels.forEach(function (p, k) { p.hidden = k !== i; if (k === i) p.classList.add('is-in'); });
      if (focus) tabs[i].focus();
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') {
          e.preventDefault();
          select((i + (e.key === 'ArrowRight' ? 1 : tabs.length - 1)) % tabs.length, true);
        }
      });
    });
    select(0);
  });

  /* 4 compare: Add to cart */
  $$('form[data-gj-add]').forEach(function (form) {
    form.addEventListener('submit', function (ev) {
      var drawer = document.querySelector('cart-drawer');
      if (!drawer || !window.fetch || !window.routes) return; // the plain post goes to the cart page
      ev.preventDefault();
      var fid = form.getAttribute('id');
      var btn = form.querySelector('button[type="submit"]') || document.querySelector('button[form="' + fid + '"]');
      var msg = form.querySelector('.gj-cmp__msg') || document.querySelector('[data-gj-msg="' + fid + '"]');
      var fd = new FormData(form);
      if (!fd.get('id')) {
        var picked = document.querySelector('input[name="id"][form="' + form.getAttribute('id') + '"]:checked');
        if (picked) fd.set('id', picked.value);
      }
      fd.append('sections', drawer.getSectionsToRender().map(function (s) { return s.id; }));
      fd.append('sections_url', window.location.pathname);
      btn.setAttribute('aria-disabled', 'true');
      btn.classList.add('is-busy');
      fetch(window.routes.cart_add_url, { method: 'POST', headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' }, body: fd })
        .then(function (r) { return r.json(); })
        .then(function (res) {
          if (res.status) { if (msg) msg.textContent = res.description || res.message || 'Sorry, that did not work.'; return; }
          if (msg) msg.textContent = '';
          drawer.classList.contains('is-empty') && drawer.classList.remove('is-empty');
          drawer.renderContents(res);
        })
        .catch(function () { form.submit(); })
        .then(function () { btn.removeAttribute('aria-disabled'); btn.classList.remove('is-busy'); });
    });
  });

  /* 5 the card's four languages */
  $$('[data-gj-langs]').forEach(function (sec) {
    var tabs = $$('[data-gj-lang]', sec);
    var lines = $$('[data-gj-line]', sec);
    var bar = sec.querySelector('[data-gj-langtabs]');
    if (!bar || !lines.length) return;
    bar.hidden = false;
    sec.classList.add('is-live');
    var i = 0, timer = null, seen = false;
    function show(k) {
      i = k;
      var code = tabs[k].getAttribute('data-gj-lang');
      tabs.forEach(function (t, n) { t.setAttribute('aria-selected', n === k ? 'true' : 'false'); });
      lines.forEach(function (l) { l.classList.toggle('is-on', l.getAttribute('data-gj-line') === code); });
    }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function start() { if (!reduce && !timer) timer = setInterval(function () { show((i + 1) % tabs.length); }, 3200); }
    tabs.forEach(function (t, k) { t.addEventListener('click', function () { stop(); seen = true; show(k); }); });
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting && !seen) start(); else stop(); });
      }, { threshold: 0.3 }).observe(sec);
    }
  });

  /* 6 journey route */
  $$('[data-gj-route]').forEach(function (sec) {
    var bar = sec.querySelector('[data-gj-routebar]');
    var stops = $$('[role="tab"]', bar);
    var panels = $$('[data-gj-stop]', sec);
    if (!bar || !stops.length) return;
    bar.hidden = false;
    sec.classList.add('is-live');
    function go(k, focus) {
      bar.style.setProperty('--pos', k);
      stops.forEach(function (s, n) { s.setAttribute('aria-selected', n === k ? 'true' : 'false'); s.tabIndex = n === k ? 0 : -1; s.classList.toggle('is-past', n < k); });
      panels.forEach(function (p, n) { var on = n === k; p.classList.toggle('is-on', on); p.setAttribute('aria-hidden', on ? 'false' : 'true'); if (on) p.removeAttribute('inert'); else p.setAttribute('inert', ''); });
      if (focus) stops[k].focus();
    }
    stops.forEach(function (s, k) {
      s.addEventListener('click', function () { go(k); });
      s.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowLeft') { e.preventDefault(); go((k + (e.key === 'ArrowRight' ? 1 : stops.length - 1)) % stops.length, true); }
      });
    });
    go(0);
  });

  /* 7 FAQ filter */
  $$('[data-gj-filter]').forEach(function (box) {
    var scope = box.closest('[data-gj-pc]') || document;
    var input = box.querySelector('input');
    var count = box.querySelector('.gj-filter__count');
    var items = $$('.gj-acc__item', scope);
    var none = $$('[data-gj-none]', scope);
    box.hidden = false;
    input.addEventListener('input', function () {
      var q = input.value.trim().toLowerCase();
      var n = 0;
      items.forEach(function (it) {
        var hit = !q || it.textContent.toLowerCase().indexOf(q) > -1;
        it.hidden = !hit;
        if (hit) n++;
        if (q && hit && n <= 2) it.open = true;
      });
      count.textContent = q ? (n === 1 ? '1 question matches' : n + ' questions match') : '';
      none.forEach(function (x) { x.hidden = !(q && n === 0); });
    });
  });

  /* 8 checklist */
  var store = null;
  try { store = window.localStorage; store.getItem('gj'); } catch (e) { store = null; }
  function tickCount() {
    $$('[data-gj-ticknote]').forEach(function (n) {
      var set = n.previousElementSibling;
      var all = set ? $$('[data-gj-tick]', set) : [];
      var done = all.filter(function (x) { return x.getAttribute('aria-pressed') === 'true'; }).length;
      if (!n.getAttribute('data-base')) n.setAttribute('data-base', n.textContent);
      n.innerHTML = '<strong>' + done + ' of ' + all.length + ' done.</strong> ' + n.getAttribute('data-base');
      n.hidden = false;
    });
  }
  $$('[data-gj-tick]').forEach(function (b) {
    var key = 'gj-tick-' + b.getAttribute('data-gj-tick');
    var li = b.closest('li');
    function set(on) { b.setAttribute('aria-pressed', on ? 'true' : 'false'); if (li) li.classList.toggle('is-done', on); }
    var saved = false;
    try { saved = store && store.getItem(key) === '1'; } catch (e) {}
    set(saved);
    b.hidden = false;
    b.addEventListener('click', function () {
      var on = b.getAttribute('aria-pressed') !== 'true';
      set(on);
      try { if (store) { if (on) store.setItem(key, '1'); else store.removeItem(key); } } catch (e) {}
      tickCount();
    });
  });
  tickCount();

  /* 8b contact: tap what the message is about; it starts the message */
  $$('[data-gj-topics]').forEach(function (box) {
    var area = document.querySelector('#ContactForm textarea, form[id^="ContactForm"] textarea, .contact textarea');
    if (!area) return;
    box.hidden = false;
    var chips = $$('[data-gj-topic]', box);
    chips.forEach(function (c) {
      c.addEventListener('click', function () {
        chips.forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        var line = 'About: ' + c.getAttribute('data-gj-topic');
        var rest = area.value.replace(/^About: .*\n?/, '');
        area.value = line + '\n' + rest;
      });
    });
  });

  /* 9 bag chooser */
  $$('[data-gj-chooser]').forEach(function (sec) {
    var answers = $$('[data-gj-answer]', sec);
    var cards = $$('[data-gj-card]', sec);
    answers.forEach(function (a) {
      a.setAttribute('role', 'button');
      a.setAttribute('aria-pressed', 'false');
      a.addEventListener('click', function (ev) {
        ev.preventDefault();
        var id = a.getAttribute('data-gj-answer');
        answers.forEach(function (x) { x.setAttribute('aria-pressed', x === a ? 'true' : 'false'); });
        var shown = null;
        cards.forEach(function (c) { var on = c.getAttribute('data-gj-card') === id; c.hidden = !on; if (on) shown = c; });
        if (shown && shown.getBoundingClientRect().bottom > window.innerHeight) {
          shown.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' });
        }
      });
    });
  });

  /* 10 header option A/B (unpublished draft only) */
  if (root.hasAttribute('data-gj-draft')) {
    var m = /[?&]gjh=(a|b)/.exec(window.location.search);
    var pick = m ? m[1] : null;
    try { if (pick) sessionStorage.setItem('gjh', pick); else pick = sessionStorage.getItem('gjh'); } catch (e) {}
    if (pick) root.setAttribute('data-gj-header', pick);
  }

  /* 11 preview links (unpublished draft only; FIX ROUND 15 Oct, critic P1). Until go-live sets each object's template
     (the gated data job), /products/<bag> and /collections/sensory-travel-bags render the OLD default templates; on the
     draft every link to them gets its ?view= so a tap from the homepage lands on the new design. Dead on the live theme
     (no data-gj-draft), and it never touches a link that already names a view. */
  if (root.hasAttribute('data-gj-draft')) {
    var views = {
      '/products/sensory-travel-bag-soft-cotton': 'bundle',
      '/products/sensory-support-bag-water-resistant': 'bundle',
      '/products/eco-sensory-support-bag': 'bundle',
      '/products/in-room-support-kit': 'in-room-kit',
      '/collections/sensory-travel-bags': 'sensory-travel-bags'
    };
    var viewFor = function (path) {
      var p = path.replace(/\/+$/, '');
      if (views[p]) return views[p];
      var m = /\/products\/[^/]+$/.exec(p); /* /collections/<c>/products/<bag> */
      return m && p.indexOf('/collections/') === 0 ? views[m[0]] || null : null;
    };
    var fix = function (a) {
      var href = a.getAttribute('href');
      if (!href || href.charAt(0) === '#' || /^(mailto|tel|javascript):/i.test(href)) return;
      var u;
      try { u = new URL(href, window.location.href); } catch (e) { return; }
      if (u.host !== window.location.host) return;
      var v = viewFor(u.pathname);
      if (!v || u.searchParams.has('view')) return;
      u.searchParams.set('view', v);
      a.setAttribute('href', u.pathname + u.search + u.hash);
    };
    $$('a[href]').forEach(fix);
    /* links added later (the cart drawer, predictive search, the menu drawer) are fixed as they are tapped */
    document.addEventListener('click', function (ev) {
      var a = ev.target && ev.target.closest ? ev.target.closest('a[href]') : null;
      if (a) fix(a);
    }, true);
  }
})();
